import React, { useCallback, useEffect, useState } from "react";
import { statusToggleFunc } from "../../customHooks";
import { debounce } from "lodash";
import DebounceInput from "react-debounce-input";
import "./SearchHeader.scss";
//import {  } from "react";
const SearchHeader = ({
  title,
  openModal,
  getSearchValue,
  setPageNo,
  searchDate,
}) => {
  const [searchValue, setSearchValue] = useState("");
  // const deferedValue = useDeferredValue(searchValue);
  const [date, setDate] = useState({ from: "", to: "" });

  const handleSearch = (e) => {
    let value = e.target.value;
    //let value = e.target.value.trimStart();
    setSearchValue(value);
    if (value.length > 1) {
      setTimeout(() => {
        getSearchValue(value);
        setPageNo(1);
      }, 1000);
    } else if (value.length === 0) {
      getSearchValue(value);
      setPageNo(1);
    }
  };

  return (
    <div className="searchHeader">
      <div className="searchHeader__title">
        <span className="searchHeader__title--span">{title}</span>
      </div>
      {title !== "Create CV" && title !== "Dashboard" && (
        <div className="searchHeader__searchBox">
          <input
            type="text"
            onChange={handleSearch}
            value={searchValue}
            name="search"
            placeholder="Search"
          />

          {/* <DebounceInput
            minLength={2}
            debounceTimeout={400}
            type="text"
            onChange={handleSearch}
            value={searchValue}
            name="search"
            placeholder="Search"
          /> */}
        </div>
      )}
      <div className="searchHeader__addbtn">
        {title == "Dashboard" ? (
          ""
        ) : title == "Setting" ? (
          ""
        ) : title == "Create CV" ? (
          ""
        ) : title == "Created CV" ? (
          ""
        ) : (
          <button onClick={openModal}>
            <i className="fa-solid fa-plus"></i> {`${title}`}
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchHeader;
